
export function createSnowball(baseSnowball) {
    const snowballClone = baseSnowball.clone();
    snowballClone.position.set(Math.random() * 10 + 20, Math.random() * 4.5 - 1.25, -2);
    snowballClone.userData.speed = Math.random() * 0.08 + 0.04;
    return snowballClone;
}

export function createTree(baseTree) {
    const treeClone = baseTree.clone();
    treeClone.position.set(Math.random() * 20 + 15, -3, Math.random() * -6 - 2);
    treeClone.rotation.set(Math.random() * 0.2 - 0.1, Math.random() * 0.2 - 0.1, Math.random() * 0.2 - 0.1);
    const scaleFactor = Math.random() * 0.09 + 0.05;
    treeClone.scale.set(scaleFactor, scaleFactor, scaleFactor);
    treeClone.userData.speed = 0.03;
    return treeClone;
}

export function createPresent(basePresent) {
    const presentClone = basePresent.clone(); 
    presentClone.position.set(8, Math.random() * 4.5 - 1.25, -2); 
    presentClone.userData.speed = Math.random() * 0.03 + 0.02; 
    presentClone.userData.rotationSpeedZ = Math.random() * 0.05 + 0.01; 
    return presentClone;
}

export function updateSingleSnowball(snowball, deltaTime) {
    snowball.position.x -= snowball.userData.speed;
    snowball.rotation.z += snowball.userData.rotationSpeedZ ?? 2.0 * deltaTime; 
    if (snowball.position.x < -8) {
        snowball.position.x = Math.random() * 10 + 15;
        snowball.position.y = Math.random() * 4.5 - 1.25;
    }
}

export function updateSingleTree(tree) {
    tree.position.x -= tree.userData.speed;
    if (tree.position.x < -15) {
        tree.position.x = Math.random() * 20 + 15;
        tree.position.y = -3;
        tree.position.z = Math.random() * -6 - 2;
    }
}

export function updateSinglePresent(present, deltaTime) {
    present.position.x -= present.userData.speed; 
    present.rotation.z += present.userData.rotationSpeedZ ?? 0.5 * deltaTime; 
    if (present.position.x < -8) { 
        present.position.x = 8; 
        present.position.y = Math.random() * 4.5 - 1.25; 
    }
}


